<script>
    import { editorState } from "@app/store/editorStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import * as m from '@app/paraglide/messages.js';

    function snapToEnd() {
        try {
            let selectedIndex =
                eventGroupState[projectState.selected].selected[0];
            const selectedEvent =
                eventGroupState[projectState.selected].events[selectedIndex];
            const validEvents = eventGroupState[
                projectState.selected
            ].events.filter(
                (event, index) =>
                    index !== selectedIndex &&
                    event.end > selectedEvent.end &&
                    event.start > 0,
            );

            if (validEvents.length === 0) return;

            // Find the event with the start time closest to selected event's end time
            const closestEvent = validEvents.reduce((closest, current) => {
                const currentDiff = Math.abs(current.start - selectedEvent.end);
                const closestDiff = Math.abs(closest.start - selectedEvent.end);

                return currentDiff < closestDiff ? current : closest;
            });

            // Update the selected event's end time to match the closest event's start time
            eventGroupState[projectState.selected].events[selectedIndex].end = closestEvent.start - (editorState.minFrameGap / projectState.frameRate);

            insertHistoryAction({
                name: "snap to end", //action name
                eventGroup: projectState.selected,
                snapshots: [
                    {
                        store: "eventGroupState",
                        value: JSON.stringify(eventGroupState),
                    },
                ],
            });
        } catch (err) {
            console.log(err);
            console.log(err.message);
        }
    }
</script>

<li class="nav-item" title={m.snap_to_end_title()}>
    <a
        id="snap-to-end-btn"
        class="nav-link"
        href="#!/"
        class:disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length === 0}
        aria-disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length === 0}
        aria-label={m.snap_to_end_aria_label()}
        role="button"
        onclick={snapToEnd}><i class="bi bi-align-end" aria-hidden="true"></i></a
    >
</li>
